import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { PublicRoute } from './PublicRoute';
import { Suspense, lazy } from 'react';
import { AuthScreenLoading } from '../components/authentication';
import * as URLS from '../constants/URLS.const';

const SignUp = lazy(() => import('../pages/auth/SignUp/SignUp'));
const SignIn = lazy(() => import('../pages/auth/SignIn/SignIn'));
const ForgotPassword = lazy(
    () => import('../pages/auth/ForgotPassword/ForgotPassword')
);

export function AuthenticationRoutes() {
    return (
        <Suspense fallback={<AuthScreenLoading />}>
            <Routes>
                <Route element={<PublicRoute />}>
                    <Route index element={<SignIn />} />
                    <Route path={URLS.ROUTE_REGISTER} element={<SignUp />} />
                    <Route
                        path={URLS.ROUTE_FORGET_PASSWORD}
                        element={<ForgotPassword />}
                    />
                    <Route
                        path="*"
                        element={<Navigate to={URLS.ROOT} replace />}
                    />
                </Route>
            </Routes>
        </Suspense>
    );
}
